module.exports = __webpack_public_path__ + "img/NUCLEO_MAL_ESTADO.png";